import { actions, getPremiumCustomersAsync } from './slices';

export const WajeezAnalysisActions = {
  ...actions,
  getPremiumCustomersAsync,
};
